var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3728 0 0 5.43731 0 12.1441C0 18.8508 5.3728 24.2882 12 24.2882C18.6272 24.2882 24 18.8508 24 12.1441C24 5.43731 18.6272 0 12 0ZM12 23.2761C5.9344 23.2761 1 18.2825 1 12.1441C1 6.00565 5.9344 1.01201 12 1.01201C18.0652 1.01201 23 6.00565 23 12.1441C23 18.2825 18.0652 23.2761 12 23.2761Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 11.9788C8.50447 11.9788 9.3999 11.0727 9.3999 9.95483C9.3999 8.837 8.50447 7.93082 7.3999 7.93082C6.29533 7.93082 5.3999 8.837 5.3999 9.95483C5.3999 11.0727 6.29533 11.9788 7.3999 11.9788Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 11.9788C17.7047 11.9788 18.6001 11.0727 18.6001 9.95483C18.6001 8.837 17.7047 7.93082 16.6001 7.93082C15.4955 7.93082 14.6001 8.837 14.6001 9.95483C14.6001 11.0727 15.4955 11.9788 16.6001 11.9788Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.6d9ebbde2388ad6a9e35d007e0217a75.svg";
export { ForwardRef as ReactComponent };